var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { setCookie, osVersion, model, isFusionBankApp } from '@tencent/vb-web-base-core';
import { webAdaptor, getDeviceInfo, getLoginInfo, getAppInfo } from '@tencent/vb-app-bridge';
import { getDeviceId } from './device';
import { axios } from '../request/request_old';
import Cookie from 'js-cookie';
function setDeviceId() {
    var deviceIdCookie = Cookie.get('deviceId');
    // 如果已经生成过了, 就不要重复生成
    if (!deviceIdCookie) {
        var visitorId = getDeviceId();
        setCookie('deviceId', visitorId);
    }
}
function setOsVersion() {
    var osVersionFromCookie = Cookie.get('osVersion');
    if (!osVersionFromCookie) {
        setCookie('osVersion', osVersion);
    }
}
// js获取不了真正的手机型号
function setModel() {
    var modelFromCookie = Cookie.get('model');
    if (!modelFromCookie) {
        setCookie('model', model);
    }
}
// 因为安卓app写入cookie到webview存在一些兼容性问题，在某些机型cookie写入需要延迟写入才写得进webview，这里h5来读取并写入
function initAppCookie() {
    return __awaiter(this, void 0, void 0, function () {
        var _a, deviceinfo, appInfo, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 4]);
                    return [4 /*yield*/, Promise.all([getDeviceInfo(), getAppInfo()])];
                case 1:
                    _a = _b.sent(), deviceinfo = _a[0], appInfo = _a[1];
                    setCookie('signkeyseq', '1');
                    setCookie('platform', '2');
                    setCookie('deviceId', deviceinfo.system.deviceId);
                    setCookie('deviceName', deviceinfo.system.deviceName);
                    setCookie('channel', appInfo.channel.id);
                    setCookie('model', deviceinfo.system.model);
                    setCookie('osVersion', deviceinfo.system.osVersion);
                    setCookie('appVersion', appInfo.version.code);
                    return [3 /*break*/, 4];
                case 2:
                    error_1 = _b.sent();
                    return [4 /*yield*/, initCookie()];
                case 3:
                    _b.sent();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
function refreshLoginInfo() {
    return __awaiter(this, void 0, void 0, function () {
        var loginInfo, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isFusionBankApp) return [3 /*break*/, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getLoginInfo()];
                case 2:
                    loginInfo = _a.sent();
                    if (loginInfo.sessionId) {
                        setCookie('sessionId', loginInfo.sessionId);
                        // ios的登陆信息没有返回gid 安排在了2.1版本
                        if (loginInfo.gid) {
                            setCookie('gid', loginInfo.gid);
                        }
                    }
                    else {
                        // 防止某些机型退出登陆之后 cookie还在
                        setCookie('sessionId', '');
                        setCookie('gid', '');
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
function initCookie() {
    setCookie('signkeyseq', '1');
    // setCookie('x-vb-channel', 'web'); 老版本中使用了x-vb-channel
    // delan: 为了保持跟app一致，用platform区分不同平台，0|iOS  1|Android 2|H5 3|小程序
    setCookie('platform', '2');
    // 转汇下单接口需要用到 channel cookie
    // 10000x 代表 IOS 渠道
    // 20000x 代表安卓渠道
    // 30000x 代表 RDM 渠道
    // 400001 代表 H5 渠道
    setCookie('channel', '400001');
    setModel();
    setOsVersion();
    setDeviceId();
}
/**
 *
 * @param launchOptions 可选，默认不填写的话不会进行灰度检测
 */
function launchInit(launchOptions) {
    return __awaiter(this, void 0, void 0, function () {
        var deviceId, noCheckGray;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    deviceId = Cookie.get('deviceId');
                    if (!isFusionBankApp) return [3 /*break*/, 3];
                    webAdaptor();
                    return [4 /*yield*/, initAppCookie()];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, refreshLoginInfo()];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    initCookie();
                    _a.label = 4;
                case 4:
                    noCheckGray = (launchOptions === null || launchOptions === void 0 ? void 0 : launchOptions.needAutoGray) === false;
                    if (!deviceId && !noCheckGray) {
                        grayCheck();
                    }
                    return [2 /*return*/];
            }
        });
    });
}
function grayCheck() {
    // 检查是否命中灰度 如果是 那么重新reload一下页面，这一步是为了reload之后 使得html有了cookie nginx通过cookie判断分配机房
    // 一进来的时候如果deviceId有值，html说明已经带上了cookie，那就说明通过html已经判断出来他是否命中灰度了 否则 在设置完cookie之后 需要通过接口判断是否命中灰度 是的话 要重新刷新下页面
    var curUrlObject = new URL(window.location.href);
    // 让url参数做出改变 来达到刷新的目的，这里不能直接调用window.location.reload 安卓富融app底下无效,grayReloadKey仅在此处用到
    curUrlObject.searchParams.set('grayReloadKey', '1');
    axios
        .head('/gray/checkGray')
        .then(function (resp) {
        // 返回值样例，tko;1或者wts;1 或者空 ;1代表命中了灰度 ；0代表没命中灰度 空代表没启用灰度
        if (resp.headers.gray && resp.headers.gray.indexOf(';1') > 0) {
            // 这里通过修改query参数来刷新页面，直接调用realod的话安卓底下无反应
            window.location.replace(curUrlObject.href);
        }
    })
        .catch(function (e) {
        console.log(e);
    });
}
export { launchInit, grayCheck };
